import { Pressable, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import VText from "components/VText";
import { useState } from "react";

const OptionSelect = ({ item, prefAnswers = [], setPrefAnswers = () => {}, answerkey = "chips" }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Pressable
            style={{
                marginBottom: spV(16),
                width: "100%",
            }}
        >
            <VText
                text={item?.question}
                style={{
                    fontSize: fp(16),
                    paddingBottom: hp(16),
                    fontWeight: "500",
                }}
            />

            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flexWrap: "wrap",
                }}
            >
                {item?.options?.map((o, idx) => {
                    const isSelected = prefAnswers?.[answerkey]?.find((n) => n?.optionId == o?.optionId) || false;
                    return (
                        <Pressable
                            style={{
                                marginBottom: hp(12),
                                borderColor: "rgba(0, 0, 0, 0.16)",
                                borderWidth: 1,
                                paddingVertical: spV(8),
                                paddingHorizontal: spH(16),
                                backgroundColor: isSelected ? "rgba(33, 36, 39, 1)" : "white",
                                marginRight: spH(12),
                                width: "45%",
                            }}
                            key={idx}
                            onPress={() => {
                                setPrefAnswers((prev) => ({
                                    ...prev,
                                    [answerkey]: [o],
                                }));
                            }}
                        >
                            <VText
                                text={o?.optionName?.slice(0, 30) || ""}
                                style={{
                                    fontSize: fp(16),
                                    textAlign: "center",
                                    paddingLeft: spH(8),
                                    color: isSelected ? "white" : "rgba(33, 36, 39, 1)",
                                }}
                                numberOfLines={1}
                            />
                        </Pressable>
                    );
                })}
            </View>
        </Pressable>
    );
};

export default OptionSelect;
